import {DroppingOddsReducer, ReducerFromState} from "../../../@types/reducers";
import {DroppingOddsClassic} from "../../../@types/inputs";


export const getClassicAlerts = (state: ReducerFromState<DroppingOddsReducer>): DroppingOddsClassic => state.odds.classicAlerts;

